import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A food experiment",
  "description": "",
  "published": "2011-12-09T00:00:00.000Z",
  "redirect_from": ["/blog/a-food-experiment/swizec/3156"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Every few days an email from Gojee winds up in my inbox with pictures of delicious delicious food to make me hungry. This week something came up that I `}{`_`}{`wanted. `}{`_`}{`It was a food so delicious looking I couldn't get it ouf o my head.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.gojee.com/food/links/wild-mushroom-stroganoff"
      }}>{`Wild Mushroom Stroganoff`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Screen-Shot-2011-12-09-at-5.07.33-PM.png",
        "alt": "Wild Mushrom Stroganoff - what I wanted to make",
        "title": "Wild Mushrom Stroganoff - what I wanted to make"
      }}></img></p>
    <p>{`After begging every female I know to make this, I finally resorted to making it myself today. Sure enough, right after I decided to make it myself a friendly female decided to lend a helping hand! Bastards.`}</p>
    <p>{`By some act of magic or divine will I actually managed to buy all the correct ingredients on my first try, unlike when I was making cake.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Screen-Shot-2011-12-09-at-5.20.07-PM.png",
        "alt": "Apparently dry mushrooms need to be soaked ...",
        "title": "Apparently dry mushrooms need to be soaked ..."
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Screen-Shot-2011-12-09-at-5.20.22-PM.png",
        "alt": "Chop chop chop",
        "title": "Chop chop chop"
      }}></img></p>
    <p>{`That pan has butter in it! Butter! Terribly against any modern notion of not-very-fatty food, but it makes all the difference.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/41e1bb62226e11e19896123138142014_75.jpg",
        "alt": "Right before the last integration testing",
        "title": "Right before the last integration testing"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/85783f08227e11e1abb01231381b65e3_75.jpg",
        "alt": "Then something went wrong and it doesn't look that great",
        "title": "Then something went wrong and it doesn't look that great"
      }}></img></p>
    <p>{`Somehow my version didn't look that much like foodporn, but damn it was delicious! Definitely going to be making this again and I think I should start using Gojee more often. They actually have some good food there.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thenextweb.com/insider/2011/11/10/cheers-to-gojee-now-with-200000-members-and-drinks-recipes/"
        }}>{`Cheers to Gojee, now with 200,000 members and Drinks recipes`}</a>{` (thenextweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2011/09/14/visually-beautiful-recipe-curation-site-gojee-raises-1-2m-from-mitch-kapor-and-others/"
        }}>{`Visually Beautiful Recipe Curation Site Gojee Raises `}{`\\`}{`\\`}{`\\`}{`\\$1.2M From Mitch Kapor And Others`}</a>{` (techcrunch.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://rollinoatstampa.com/2011/09/17/link-lovin-tofu-mushroom-stroganoff/"
        }}>{`Link Lovin': Tofu Mushroom Stroganoff`}</a>{` (rollinoatstampa.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2011/11/10/visually-beautiful-recipe-curation-site-gojee-adds-drinks-to-the-mix/"
        }}>{`Visually Beautiful Recipe Curation Site Gojee Adds Drinks To The Mix`}</a>{` (techcrunch.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=a56a01cf-521e-4131-9fbd-0ec1d172a356",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      